export default "assets/images/logo.png";